import type { LoginAction } from '../types';
import authActionNames from './constants';

export default class LoginActionProvider {
  static credentials(email: string, password: string): LoginAction {
    return {
      type: authActionNames.LOGIN_WITH_CREDENTIALS,
      payload: { data: { email, password } },
    };
  }

  static google(tokenId: string): LoginAction {
    return {
      type: authActionNames.LOGIN_WITH_GOOGLE,
      payload: { data: { token: tokenId } },
    };
  }

  static facebook(accessToken: string): LoginAction {
    return {
      type: authActionNames.LOGIN_WITH_FACEBOOK,
      payload: { data: { token: accessToken } },
    };
  }
}
